<template>
    <div>
        <a-row>
            <a-col :span="1">
                <a-button type="primary" @click="visible=true">
                    新增
                </a-button>
            </a-col>
        </a-row>
        <a-table :columns="columns" :data-source="data.data" :pagination="false" rowKey="id">
            <template slot="operation" slot-scope="text,row">
                <a style="padding-left:5px;" @click="edit(row)">编辑</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px" @click="editMenu(row)">编辑菜单</a>
                <a-divider type="vertical"/>
                <a style="padding-left:5px;color:red" @click="del(row)">删除</a>
            </template>
        </a-table>
        <my-page :data="data" @change="onChange"/>
        <a-modal v-model="visible" title="编辑权限信息" ok-text="确定" cancel-text="取消" @ok="add"
                 @cancel="resetForm">
            <a-form-model ref="roleForm" :rules="rules" :model="form" :label-col="{ span: 4 }"
                          :wrapper-col="{ span: 20 }">
                <a-form-model-item label="序号">
                    <a-input-number style="width: 100%" v-model.trim="form.orderNo"/>
                </a-form-model-item>
                <a-form-model-item label="权限名称" prop="name">
                    <a-input v-model="form.name"/>
                </a-form-model-item>
                <a-form-model-item label="权限代码" prop="code">
                    <a-input v-model="form.code"/>
                </a-form-model-item>
                <a-form-model-item label="权限描述">
                    <a-input v-model="form.descpt"/>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <a-modal v-model="menuVisible"
                 title="编辑角色具有权限"
                 width="60%"
                 :bodyStyle="{height: '60vh'}"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="addMenu"
                 @cancel="resetForm">
            <a-spin :spinning="spinning">
                <a-tree
                        v-model="selectMenuList"
                        :checkable="true"
                        style="min-height:55vh;max-height:55vh;overflow:scroll;"
                        :replaceFields="{title:'name', key:'id'}"
                        :auto-expand-parent="true"
                        :tree-data="menuList"
                />
            </a-spin>
        </a-modal>
        <a-modal v-model="delVisible"
                 title="提示"
                 width="400px"
                 ok-text="确定"
                 cancel-text="取消"
                 @ok="delOk"
                 @cancel="cancel">
            <a class="Tips">是否确定删除!</a>
        </a-modal>
    </div>
</template>

<script>
    import {
        getPowerQueryList,
        powerEditDetail,
        powerDelDetail,
        getMenuList,
        powerQueryMenu,
        powerEditMenu
    } from "./js/ApiRole";
    import notification from 'ant-design-vue/es/notification'

    const columns = [
        {
            title: '序号',
            dataIndex: 'orderNo',
            key: 'orderNo',
            ellipsis: true,
        },
        {
            title: '权限名称',
            dataIndex: 'name',
            key: 'name',
            ellipsis: true,
        },
        {
            title: '权限代码',
            dataIndex: 'code',
            key: 'code',
            ellipsis: true,
        },
        {
            title: '权限描述',
            dataIndex: 'descpt',
            key: 'descpt',
            ellipsis: true,
        },
        {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            wdith: 400,
            scopedSlots: {customRender: 'operation'},
        }
    ];
    export default {
        data() {
            return {
                columns,
                data: {},
                visible: false,
                delVisible: false,
                orgList: [],
                dataPowerLevelList: [],
                rules: {
                    name: [{required: true, message: '请输入权限名称', trigger: 'blur'}],
                    code: [{required: true, message: '请输入权限代码', trigger: 'blur'}]
                },
                form: {
                    orderNo: '',
                    name: '',
                    code: '',
                    descpt: ''
                },
                spinning: false,
                menuVisible: false,
                selectMenuList: [],
                menuList: [],
                line: {},
            }
        },
        methods: {
            //新增
            add() {
                this.form.orderNo = this.form.orderNo + '';
                this.$refs.roleForm.validate(valid => {
                    if (valid) {
                        powerEditDetail(this.form).then(() => {
                            this.getData()
                        })
                    }
                });
            },
            editMenu(row) {
                this.spinning = true;
                this.line = row;
                powerQueryMenu({id: row.id}).then(res => {
                    this.spinning = false;
                    if (res.data.data.suMenus) {
                        let powerList = [];
                        res.data.data.suMenus.forEach(item => {
                            powerList.push(item.id)
                        });
                        this.selectMenuList = powerList;
                    }
                    this.menuVisible = true
                }).catch(() => {
                    this.spinning = false;
                    this.menuVisible = false;
                    notification.error({
                        message: '权限菜单加载失败，请检查网络环境',
                    });
                });
            },
            addMenu() {
                let selectMenuList = [];
                this.selectMenuList.forEach(item => {
                    selectMenuList.push({id: item});
                });
                this.line.suMenus = selectMenuList;
                powerEditMenu(this.line).then(() => {
                    this.getData();
                })
            },
            edit(row) {
                this.form = JSON.parse(JSON.stringify(row));
                this.visible = true
            },
            //删除
            del(row) {
                this.delVisible = true;
                this.line = row;
            },
            delOk(){
                powerDelDetail({id: this.line.id}).then(() => {
                    this.getData();
                    this.delVisible = false;
                }).catch(()=>{
                    this.delVisible = false;
                })
            },
            cancel(){
                this.delVisible = false;
            },
            getData(parameter) {
                this.resetForm();
                if (!parameter) {
                    parameter = {}
                }
                getPowerQueryList(parameter).then(res => {
                    this.data = res.data;
                });
                this.visible = false;
                this.menuVisible = false;
            },
            /**
             * 重置form
             */
            resetForm() {
                if (this.$refs.userForm !== undefined) {
                    this.$refs.userForm.clearValidate();
                }
                this.form = {
                    name: '',
                    code: '',
                    descpt: ''
                };

                this.spinning = false;
                this.menuVisible = false;
                this.selectMenuList = [];
                this.line = {};
            },
            // 分页
            onChange(page) {
                let baseDto = {
                    pageIndex: page,
                    pageSize: 10,
                };
                getPowerQueryList({baseDto: baseDto}).then(res => {
                    this.data = res.data;
                })
            },
        },
        created() {
            this.getData();
            getMenuList({}).then(res => {
                this.menuList = res.data.data
            })
        }
    }
</script>

<style scoped>
    .Tips{
        font-size: 20px;
        color: #1890ff;
    }
</style>
